import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { omit } from 'lodash/fp';
import { Content, Loader } from 'rsuite';
import InventoryLocationForm from '../../../containers/inventory/LocationForm';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import {
  updateInventoryLocation,
  fetchInventoryLocation,
  fetchInventoryLocationZones
} from '../../../redux/Inventory/sagas/routines';
import {
  getIsFetching,
  getIsSaving,
  getIsSaved,
  getLocationForId
} from '../../../redux/Inventory/selectors/location';
import { getZonesForLocationId } from '../../../redux/Inventory/selectors/location-zone';
import {
  InventoryLocationType,
  InventoryLocationZoneType
} from '../../../interfaces/inventory';

export class ViewInventoryLocation extends Component {
  static propTypes = {
    location: InventoryLocationType,
    zones: PropTypes.arrayOf(InventoryLocationZoneType),
    isFetching: PropTypes.bool.isRequired,
    onInit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  static defaultProps = {
    location: null,
    zones: []
  };

  constructor(props) {
    super(props);
    this.state = { isInit: false };
  }

  componentDidMount() {
    const { isInit } = this.state;
    const { onInit } = this.props;
    if (!isInit) {
      onInit();
      this.setState({ isInit: true });
    }
  }

  render() {
    const { isFetching, location, zones, onSubmit } = this.props;
    return (
      <InventoryPageLayout>
        <PageHeader title="Edit Location" />
        <Content>
          {isFetching ? (
            <Loader backdrop content="loading..." vertical />
          ) : (
            <InventoryLocationForm
              location={location}
              zones={zones}
              onSubmit={onSubmit}
            />
          )}
        </Content>
      </InventoryPageLayout>
    );
  }
}

function mapStateToProps(state, { match: { params } }) {
  const { id: locationId } = params;
  return {
    location: getLocationForId(state, locationId),
    zones: getZonesForLocationId(state, locationId),
    isFetching: getIsFetching(state),
    isSaved: getIsSaved(state),
    isSaving: getIsSaving(state)
  };
}

function mapDispatchToProps(dispatch, { match: { params } }) {
  return {
    onInit: () => {
      dispatch(
        fetchInventoryLocationZones({ qs: { inventoryLocationId: params.id } })
      );
      dispatch(fetchInventoryLocation({ id: params.id }));
    },
    onSubmit: body => {
      const omitProps = ['id', 'createdAt', 'updatedAt', 'deletedAt'];
      const payload = { id: body.id, body: omit(omitProps, body) };
      dispatch(updateInventoryLocation(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewInventoryLocation);
